// Client-side fallback for the narrative data (verbatim). Used if the backend
// request fails so the experience never stalls. Matches /api/narrative/* shape.

export const FALLBACK_POVS = [
  {
    id: "stanley", name: "Stanley Praimnath", role: "VP, Fuji Bank",
    floor: "81st Floor", vantage: "Trapped beneath desk / drywall breach",
    interaction: "Tap 'Wall Vector' to emit spatialized sound rings.", tint: "#f2c85b",
  },
  {
    id: "brian", name: "Brian Clark", role: "EVP, Euro Brokers · Fire Warden",
    floor: "84th Floor", vantage: "First-person with flashlight",
    interaction: "Align 'Flashlight Vector' with Stanley's sound origin.", tint: "#62a8e5",
  },
];

const RAW = [
  [10, "impact", "Stanley Praimnath", "stanley", "8:46 AM", "Delise, look at the North Tower! That's fire—we need to get out of here right now."],
  [11, "impact", "Building PA System", "stanley", "~8:55 AM", "Your attention please. The South Tower is secure. You may return to your offices."],
  [12, "impact", "Stanley Praimnath", "stanley", "9:01 AM", "I'm back at my desk... Wait, what did you say? Turn on the TV?"],
  [13, "impact", "Stanley Praimnath", "stanley", "9:02 AM", "Oh, Lord... Lord, I surrender everything to you!"],
  [20, "acoustic", "Stanley Praimnath", "stanley", "Post-Impact", "Help! Somebody help me! I have a wife and two daughters! I can't die here!"],
  [21, "acoustic", "Brian Clark", "brian", "Post-Impact", "I can hear you! Keep shouting so I can find you!"],
  [22, "acoustic", "Brian Clark", "brian", "Post-Impact", "Keep knocking on the wall so I know where you are!"],
  [23, "acoustic", "Stanley Praimnath", "stanley", "Post-Impact", "Here! Right here behind the wall!"],
  [30, "flashlight", "Brian Clark", "brian", "Localization", "I see a gap! Punch through if you can, give me your hand!"],
  [31, "flashlight", "Stanley Praimnath", "stanley", "Localization", "Take my hands!"],
  [40, "wristlock", "Brian Clark", "both", "The Pull", "Gotcha! I've got you! Up and over!"],
  [41, "wristlock", "Stanley Praimnath", "both", "The Pull", "Thank you... My name is Stanley Praimnath."],
  [42, "wristlock", "Brian Clark", "both", "The Pull", "My name is Brian Clark. You know, Stanley... I've always wanted a brother."],
  [50, "stairwell", "Survivor Group", "both", "Egress Decision", "The stairs below are destroyed! We have to go up to the roof and wait for helicopter rescue!"],
  [51, "stairwell", "Brian Clark", "both", "Egress Decision", "We don't know that for sure. We need to test the route going down first."],
  [52, "stairwell", "Stanley Praimnath", "both", "Egress Decision", "If there's a way through, we take it. Let's see if Stairwell A is open."],
  [53, "stairwell", "Brian Clark", "both", "Egress Decision", "The shaft structure is intact. Follow me—stay on the stairs and keep moving."],
  [60, "descent", "Brian Clark", "both", "The Descent", "Watch your step here. Focus on the ground right beneath your feet, one floor at a time."],
  [61, "descent", "Stanley Praimnath", "both", "The Descent", "Keep going! Don't stop now, just keep moving down!"],
  [62, "descent", "Brian Clark", "both", "The Descent", "Clear the landing, step by step. We're getting through this together."],
  [70, "exit", "Stanley Praimnath", "both", "Street Level", "Brian... I think the building is going to fall down."],
  [71, "exit", "Brian Clark", "both", "Street Level", "It's a steel structure, Stan. It can't possibly—"],
  [72, "exit", "Stanley Praimnath", "both", "Street Level", "Run! We have to move!"],
];

export const FALLBACK_DIALOGUE = RAW.map(
  ([order, phase, speaker, pov, time_label, text]) => ({ order, phase, speaker, pov, time_label, text })
);

export function fallbackDialogue(pov, phase) {
  return FALLBACK_DIALOGUE
    .filter((d) => (d.pov === pov || d.pov === "both") && (!phase || d.phase === phase))
    .sort((a, b) => a.order - b.order);
}

export const FALLBACK_BIBLIOGRAPHY = [
  { claim: "The 56-minute window", detail: "United Flight 175 struck the South Tower at 9:02:59 AM; the tower collapsed at 9:58:59 AM — a 56-minute survival window.", source: "NIST NCSTAR 1" },
  { claim: "102 minutes of total events", detail: "The full span from the first strike (8:46 AM) to the North Tower's collapse (10:28 AM) totalled 102 minutes.", source: "Dwyer & Flynn, '102 Minutes'" },
  { claim: "Stairwell A", detail: "The only stairwell that remained passable below the impact zone in the South Tower.", source: "The 9/11 Commission Report, Ch. 9" },
  { claim: "The rescue account", detail: "Brian Clark located Stanley by the sound of him pounding the drywall and pulled him through the breach.", source: "Stanley Praimnath interview + Brian Clark archival record" },
];
